import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { getDataLayer } from '../selectors/AnalyticsSelector';

export class AnalyticsContainer extends BcReactComponent {
  componentDidUpdate(prevProps) {
    const prevDataLayer = prevProps.dataLayer;
    const nextDataLayer = this.props.dataLayer;

    // Pushes new data into the global dataLayer.
    // Sets removed data to `undefined` in the global dataLayer.
    if (window.dataLayer) {
      const addedData = nextDataLayer.filter((val, key) => !prevDataLayer.has(key));
      const removedData = prevDataLayer.filter((val, key) => !nextDataLayer.has(key));

      if (removedData.size || addedData.size) {
        window.dataLayer.push({
          ...addedData.toJS(),
          ...removedData.map(() => undefined).toJS()
        });
      }
    }
  }

  render() {
    return null;
  }
}

AnalyticsContainer.propTypes = {
  dataLayer: ImmutablePropTypes.map
};

const mapStateToProps = (state) => ({
  dataLayer: getDataLayer(state)
});

export default connect(mapStateToProps)(AnalyticsContainer);



// WEBPACK FOOTER //
// ./app/containers/AnalyticsContainer.jsx